/*=========================================================================================
	File Name: moduleAuthMutations.js
	Description: Auth Module Mutations
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'
import mainState from "../state.js"
import Vue from 'vue';
export default {
	REMOVE_ACCEPTED_ALL_BARCODES(state, item) {
		state.AcceptedBarcodes = []
		localStorage.setItem("acceptedBarcodes", JSON.stringify(state.AcceptedBarcodes));
	},
	REMOVE_ACCEPTED_BARCODES_EXCEL(state, payload) {
		const index = state.AcceptedBarcodes.findIndex(item =>
			item.barcode === item.barcode &&
			item.serials.some(serial => serial.value === payload.serial[0].value)
		);
		if (index > -1) { state.AcceptedBarcodes.splice(index, 1) }
		localStorage.setItem("acceptedBarcodes", JSON.stringify(state.AcceptedBarcodes));
	},

	REMOVE_ACCEPTED_BARCODES(state, item) {
		const index = state.AcceptedBarcodes.findIndex(i => i.barcode === item.barcode)
		if (index > -1) { state.AcceptedBarcodes.splice(index, 1) }
		localStorage.setItem("acceptedBarcodes", JSON.stringify(state.AcceptedBarcodes));
	},



	REDUCE_ACCEPTED_BARCODES(state, payload) {

		const index = state.AcceptedBarcodes.findIndex(item =>
			item.barcode === item.barcode &&
			item.serials.some(serial => serial.value === payload.serial[0].value)
		);
		if (index > -1) {
			if (state.AcceptedBarcodes[0].qEntery == 0) {
				state.AcceptedBarcodes[index].qExit = state.AcceptedBarcodes[index].qExit - 1;
				if (state.AcceptedBarcodes[index].qExit <= 0) { state.AcceptedBarcodes.splice(index, 1) }
			}
			else {
				state.AcceptedBarcodes[index].qEntery = state.AcceptedBarcodes[index].qEntery - 1;
				if (state.AcceptedBarcodes[index].qEntery <= 0) { state.AcceptedBarcodes.splice(index, 1) }
			}

		}
		localStorage.setItem("acceptedBarcodes", JSON.stringify(state.AcceptedBarcodes));
	},
	STOCK_TRANS_LIST(state, item) {
		state.AcceptedBarcodes = item
	},
	SET_ACCEPTED_BARCODES(state, item) {
		state.AcceptedBarcodesAll = item
	},
	UPDATE_ACCEPTED_BARCODES_SERIAL(state, payload) {
		const index = state.AcceptedBarcodes.findIndex(item =>
			item.barcode === payload.barcode &&
			item.serials.some(serial => serial.value == payload.serials[0].value)
		);
		state.AcceptedBarcodes[index].serials = payload.serials
		state.AcceptedBarcodes[index].serialStatus = true
		localStorage.setItem("acceptedBarcodes", JSON.stringify(state.AcceptedBarcodes));

	},
	UPDATE_ACCEPTED_BARCODES(state, payload) {
		const index = state.AcceptedBarcodes.findIndex(i => i.barcode === payload.barcode)
		if (state.AcceptedBarcodes[index].trasnType == "5") {
			state.AcceptedBarcodes[index].qExit += payload.qEntery
			if (state.AcceptedBarcodes[index].qExit < 0) { state.AcceptedBarcodes[index].qExit = 0; state.AcceptedBarcodes.splice(index, 1); }
			localStorage.setItem("acceptedBarcodes", JSON.stringify(state.AcceptedBarcodes));
		} else {
			state.AcceptedBarcodes[index].qEntery += payload.qEntery
			if (state.AcceptedBarcodes[index].qEntery < 0) { state.AcceptedBarcodes[index].qEntery = 0; state.AcceptedBarcodes.splice(index, 1); }
			localStorage.setItem("acceptedBarcodes", JSON.stringify(state.AcceptedBarcodes));
		}

	},
	ADD_ACCEPTED_BARCODES(state, item) {
		let itemLocal = {
			"stockTrasnId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
			"transDate": item.title.createdDate,
			"barcode": item.title.barcode.toString(),
			Stockno: item.value.Stockno,

			StockName: item.value.StockName,
			"trasnType": item.title.transType, //"1": "Entrance", "2": "Return", "3": "Cancaled", "4": "Updated", "5": "Exit", "6": "Transfer"
			transTypeName: item.title.transTypeName,
			"description": item.title.description,
			"groupCode": item.title.transactionNo,
			"specCode1": item.value.SpecCode1,
			"specCode2": item.value.SpecCode2,
			"stockId": item.value.StockId,
			"transCode": item.title.transactionNo,
			"qEntery": item.title.transType == "5" ? 0 : item.title.quantity,
			"qExit": item.title.transType == "5" ? item.title.quantity : 0,
			"depotName": item.title.depotName,
			"companyName": item.title.customerName,
			"companyId": item.title.companyId,
			"createDate": item.title.createdDate,
			"depotId": item.title.depotId,
			"userId": mainState.AppActiveUser.userId,
			supplierName: item.title.supplierName,
			supplierId: item.title.supplierId,
			supplierCode: item.title.supplierCode,
			SerialFollow: item.value.SerialFollow
		}
		if (item.value.SerialFollow) {
			itemLocal.serials = item.title.serials
			itemLocal.serialStatus = item.value.SerialFollow
		}
		if (state.AcceptedBarcodes) {
			state.AcceptedBarcodes.push(Object.assign({}, itemLocal))
		}
		localStorage.setItem("acceptedBarcodes", JSON.stringify(state.AcceptedBarcodes));
	},

	ACCEPTED_BARCODES(state, value) {
		localStorage.setItem("acceptedBarcodes", JSON.stringify(value));
		state.AcceptedBarcodes = value;
	},
	BANAYENI_TAGS_LIST(state, value) {
		state.BanayeniTagsList = value;
	},
	PRODUCT_EXPERTIZE_HEAD(state, value) {
		state.ProductExpertizeHead = value;

	},
	PRODUCT_EXPERTIZE_LIST(state, value) {
		state.ProductExpertizeList = value;

	},
	STOCK_TRANS_TYPE_LIST(state, value) {
		state.StockTransType = value;

	},
	STOCK_LIST(state, value) {
		state.Stock = value;

	},
	STOCK_BUNDLE_LIST(state, value) {
		state.StockBundle = value;

	},
	STOCK_GROUP_EXPERTIZE_LIST(state, value) {
		state.StockGroupExpertize = value;

	},
	STOCK_EXPERTIZE_LIST(state, value) {
		state.StockExpertize = value;

	},
	STOCK_SERIAL_LIST(state, value) {
		state.StockSerialNumbers = value;

	},
	STOCK_BARCODE_LIST(state, value) {
		state.StockWithBarcodes = value;

	},
	STOCK_TAKING_LIST(state, item) {
		state.StockTaking = item

	}, STOCK_TAKING_ITEM(state, item) {
		state.StockTakingItem = item

	},
	STOCK_TRANS_ALL_TYPES(state, item) {
		state.StockTransAllTypes = item
	},
	STOCK_TRANS_ALL_ITEM_LIST(state, item) {
		state.StockItemsAll = item
	},
	STOCK_TRANS_ALL_LIST(state, item) {
		state.StockTransAll = item
	},
	STOCK_TRANS_DETAIL_LIST(state, item) {
		state.StockTransDetail = item
	},
	STOCK_BARCODES_LIST(state, value) {
		state.StockBarcodes = value
	},
	UPDATE_ITEM_STOCK(state, updatedProduct) {
		const productIndex = state.Stock.findIndex(p => p.StockId === updatedProduct.stockId);
		const output = Object.entries(updatedProduct).map(([key, value]) => {
			const safeValue = value === undefined || value === null ? '' : value;
			return [key[0].toUpperCase() + key.slice(1), safeValue];
		});
		if (productIndex !== -1) {
			Vue.set(state.Stock, productIndex, Object.assign({}, Object.fromEntries(output)));
		}
	},
	ADD_ITEM_STOCK(state, item) {
		const output = Object.entries(item).map(([key, value]) => [
			key[0].toUpperCase() + key.slice(1), value,]);
		state.Stock.push(Object.assign({}, Object.fromEntries(output)))
	},
	DELETE_ITEM_STOCK(state, item) {
		const index = state.Stock.findIndex(i => i.StockId === item)
		if (index > -1) { state.Stock.splice(index, 1) }
	}
}
